import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { Themes } from '../theme.types.js';
import neutral from '../neutral/index.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var components = {
  name: Themes.MESTARIN_HERKKU,
  accordion: _objectSpread({}, neutral.components.accordion),
  alert: _objectSpread({}, neutral.components.alert),
  button: _objectSpread({}, neutral.components.button),
  checkbox: _objectSpread({}, neutral.components.checkbox),
  datePicker: _objectSpread({}, neutral.components.datePicker),
  drawer: _objectSpread({}, neutral.components.drawer),
  form: _objectSpread({}, neutral.components.form),
  grid: _objectSpread({}, neutral.components.grid),
  input: _objectSpread({}, neutral.components.input),
  modal: _objectSpread({}, neutral.components.modal),
  popover: _objectSpread({}, neutral.components.popover),
  select: _objectSpread({}, neutral.components.select),
  "switch": _objectSpread({}, neutral.components["switch"]),
  radio: _objectSpread({}, neutral.components.radio),
  tab: _objectSpread({}, neutral.components.tab),
  tag: _objectSpread({}, neutral.components.tag)
};

export { components };
//# sourceMappingURL=components.js.map
